import { CalendarDays } from "lucide-react";
import { Calendar } from "../components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../components/ui/popover";

function tanggalDariNilai(nilai) {
  const [tahun, bulan, hari] = nilai.split("-").map(Number);
  return new Date(tahun, bulan - 1, hari);
}

function nilaiDariTanggal(tanggal) {
  const tahun = tanggal.getFullYear();
  const bulan = String(tanggal.getMonth() + 1).padStart(2, "0");
  const hari = String(tanggal.getDate()).padStart(2, "0");
  return `${tahun}-${bulan}-${hari}`;
}

export default function TanggalPilihan({ id, nilai, onUbah, testid, label }) {
  const terpilih = tanggalDariNilai(nilai);
  const labelTanggal = new Intl.DateTimeFormat("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(terpilih);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          id={id}
          type="button"
          data-testid={testid}
          aria-label={label}
          className="mt-1 flex w-full items-center justify-between border bg-background px-2 py-1.5 text-left text-sm"
        >
          <span>{labelTanggal}</span>
          <CalendarDays size={16} aria-hidden="true" className="text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={terpilih}
          onSelect={(tanggal) => tanggal && onUbah(nilaiDariTanggal(tanggal))}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}